<template>
  <div class="c-table" ref="recordDetailtable">
    <Spin size="large" fix v-if="loading"></Spin>
    <el-table class="common-el-table-styles" :data="data" :height="height" border stripe @sort-change="sortChange">
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
        :sortable="col.sortable"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <span v-if="col.key === 'cpRate'">{{ scope.row[col.key] | toPercent }}</span>
          <span v-else-if="col.key === 'amount'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'thirtySynthesizeMoney'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'thirtySynthesizeDeviceMoney'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'thirtySynthesizeCreateRoleMoney'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'thirtyNewRoleMoney'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'thirtyNewDeviceMoney'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'thirtyCreateRoleMoney'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'thirtySynthesizeRetain'">{{ scope.row[col.key] | toPercent }}</span>
          <span v-else-if="col.key === 'thirtySynthesizeDeviceRetain'">{{ scope.row[col.key] | toPercent }}</span>
          <span v-else-if="col.key === 'thirtySynthesizeCreateRoleRetain'">{{ scope.row[col.key] | toPercent }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'recordDetailtable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  },
  methods: {
    sortChange(column) {
      let orderName
      if (column.order === 'ascending') orderName = 'asc'
      else if (column.order === 'descending') orderName = 'desc'
      this.$emit('on-sort', { sort: column.prop, order: orderName })
    }
  }
}
</script>
